import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import authService from '../api-authorization/AuthorizeService';
import AdminFunctions from './AdminFunctions';
import Session from '../auth/Session'

function CreateClient(props) {

    const navigate = useNavigate();

    const [clientName, setClientName] = useState('');
    const [success, setSuccess] = useState(undefined);



    useEffect(() => {
        async function fetchIsAdmin() {
            const isAdmin = AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                navigate('/accessdenied');
            }
        }
        fetchIsAdmin();
    })

    const createClient = async () => {

        const token = Session.getToken();
        const name = clientName;
        if (name) {
            const dto = {
                id: 0,
                name: name
            };
            const response = await fetch('api/Admin/AddClientAsync', {
                method: 'POST',
                body: JSON.stringify(dto),
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            setSuccess(data);
        }
    }
    return (
        <div>
            <Container style={{ marginTop: '50px' }}>
                <Row>
                    <Col>
                        <h3>Create Client</h3>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col xl='10' lg='10' md='10' sm='10' xs='10'>
                        <Input
                            type='text'
                            onChange={(e) => setClientName(e.target.value)}
                            name='clientName'
                            id='clientName'
                            placeholder='Name'
                        />
                    </Col>
                    <Col xl='2' lg='2' md='2' sm='2' xs='2'>
                        <Button
                            color='primary'
                            onClick={() => createClient()}
                        >
                            Create
                        </Button>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        {success === true && (
                            <Alert color='success'>
                                Client added successfully!
                            </Alert>
                        )}
                        {success === false && (
                            <Alert color='danger'>
                                Error adding Client!
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Container>
        </div >
    )



}
export default CreateClient;